// Generated by CoffeeScript 1.10.0
(function() {
  var Image, _;

  _ = require('underscore');

  Image = require('./image');

  module.exports = {
    imageUrl: function(version, i) {
      var img, imgs, ref, ref1, ref2, ref3, url, v;
      if (version == null) {
        version = 'larger';
      }
      imgs = this.get('images');
      if (!(imgs != null ? imgs.length : void 0)) {
        return;
      }
      if (i) {
        img = _.findWhere(imgs, {
          position: i
        }) || imgs[i] || imgs[0];
      } else {
        img = _.findWhere(imgs, {
          is_default: true
        }) || imgs[0];
      }
      if (!img) {
        return;
      }
      url = (ref = img.image_urls) != null ? ref[version] : void 0;
      if (v = (ref1 = img.image_versions) != null ? ref1[version] : void 0) {
        url || (url = (ref2 = img.image_url) != null ? ref2.replace(':version', v) : void 0);
      }
      url || (url = _.values(img.image_urls)[0]);
      url || (url = (ref3 = img.image_url) != null ? ref3.replace(':version', _.first(img.image_versions)) : void 0);
      return url;
    },
    isComparable: function() {
      return (this.get('comparables_count') > 0) && (this.get('category') !== 'Architecture');
    },
    isPriceDisplayable: function() {
      return (this.has('price')) && !this.isMultipleEditions() && (this.get('inquireable') || this.get('sold')) && !this.isUnavailableButInquireable() && this.get('sale_message') !== 'Contact For Price';
    },
    isContactable: function() {
      return this.get('forsale') && this.has('partner') && !this.get('acquireable');
    },
    isMultipleEditions: function() {
      var ref;
      return ((ref = this.get('edition_sets')) != null ? ref.length : void 0) > 1;
    },
    isUnavailableButInquireable: function() {
      return !this.get('forsale') && this.get('inquireable') && !this.get('sold');
    }
  };

}).call(this);
